import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['eventId'],
  data: function data() {
    var validateDuration = function validateDuration(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入比赛时长'));
      } // 匹配 分:秒.百毫秒 格式


      var reg = /^\d+:[0-5]\d\.\d{2}$/;

      if (!reg.test(value)) {
        return callback(new Error('格式不正确，请输入 x:xx.xx 格式'));
      }

      callback();
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        activation_code: '',
        score: '',
        duration: '',
        student_id: '',
        format_time: ''
      },
      studentList: [],
      activationList: [],
      rules: {
        activation_code: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        score: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        duration: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }, {
          validator: validateDuration,
          trigger: 'blur'
        }],
        student_id: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, duration, student_id, score, activation_code, format_time;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getStudentList();

              case 2:
                _context.next = 4;
                return _this.getCodeList();

              case 4:
                if (data) {
                  id = data.id, duration = data.duration, student_id = data.student_id, score = data.score, activation_code = data.activation_code, format_time = data.format_time;
                  _this.formData = {
                    id: id,
                    duration: duration,
                    student_id: student_id,
                    score: score,
                    activation_code: activation_code,
                    format_time: format_time
                  };

                  if (_this.formData.format_time != '0') {
                    _this.formData.duration = _this.formData.format_time;
                  }
                } else {
                  _this.formData.id = '';
                }

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    getCodeList: function getCodeList() {
      var _this2 = this;

      this.$api.activationCodeList({
        page_size: -1,
        event_id: this.eventId
      }).then(function (res) {
        if (res.code == 200) {
          _this2.activationList = res.data;
        }
      });
    },
    getStudentList: function getStudentList() {
      var _this3 = this;

      this.$api.eventParticipantList({
        page_size: -1,
        event_id: this.eventId
      }).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.student_name = item.student.name;
            item.id_card = item.student.id_card;
          });
          _this3.studentList = data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this4.formData));

                    if (data.duration) {
                      var newDuration = data.duration;
                      data.format_time = newDuration;
                      data.duration = _this4.$utils.parseDuration(newDuration);
                    }

                    var reqFn = data.id ? 'scoreDetailUpdate' : 'scoreDetailAdd';

                    _this4.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                      event_id: _this4.eventId
                    })).then(function (res) {
                      if (res.code == 200) {
                        _this4.$message.success(_this4.formData.id ? '修改成功' : '添加成功');

                        _this4.$emit('change');

                        _this4.dialogFormVisible = false;
                      } else {
                        _this4.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};